import React, { useState } from "react";

import { actions } from "../../actions";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Empty, Card ,Statistic} from "antd";

import "./forWho.css";


function ForWho (props)  {
  const [loader, SetLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [error,setError] = useState("")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleSubmit } = props;
  const onSubmit = () => {
    let dataToSend = { email: email };
    let inputData = { email: email };
    SetLoader(true);

    dispatch(actions.SignIn(dataToSend, (error, status) => {
      if (!error) {
        navigate("/otp", { state: { inputData, type: "login" } });
        SetLoader(false);
      } else {
        // Handle the error case
        SetLoader(false);
        console.error("API Error:", error);
        let e = error.split("or")
        setError(e[0] + "signup first")
       // setErrorMessage(error); // Set the error message in state
      }
    }));
  };

  const handleSignin = () => {
    navigate('/login')
  };

  const handleSignup = () => {
    navigate('/signup')
  };
  return (
<div className="forWho-wrapper">
  <div className="forWho-heading">
    Who is QuallyHire for?
  </div>

  <div className="forWho-card-wrapper">
    
    {/* Recruiters */}
    <div className="forWho-card">
      <Card bordered={false}>
        <h3>For Recruiters </h3>
        <p>
          Automate hiring, manage pipelines, and reduce time-to-hire with AI-powered workflows.
        </p>
        <Button className="btn-green-outline" onClick={() => navigate("/qhrflow")}>
          Explore Hiring Platform
        </Button>
      </Card>
    </div>

    {/* Staffing */}
    <div className="forWho-card">
      <Card bordered={false}>
        <h3>For Companies</h3>
        <p>
          Manage multiple clients, vendors, and candidates efficiently from a single dashboard.
        </p>
        <Button className="btn-green-outline"  onClick={() => navigate("/qhrflow")}>
          Explore Hiring Platform
        </Button>
      </Card>
    </div>

    {/* Candidates */}
    <div className="forWho-card">
      <Card bordered={false}>
        <h3>For Job Seekers</h3>
        <p>
          Discover relevant jobs, create your profile, evalutions and get real-time job alerts.
        </p>
        <Button className="btn-green-outline"  onClick={() => navigate("/nujobs")}>
          Find Jobs
        </Button>
      </Card>
    </div>

  </div>
</div>
     
  );
};

export default ForWho;
